/* Contador que sube hasta el número, al entrar en pantalla.
   - El valor FINAL ya está pintado en el HTML: sin JS (o si falla) se ve el
     número correcto, nunca un "0" roto. El 0 solo aparece durante la animación,
     que corre cuando el elemento ya está a la vista.
   - Respeta prefers-reduced-motion (deja el valor final, sin animar).
   - Formatea con separador de miles es-CL (15000 -> 15.000).
   - Reinicia en el editor de tema (shopify:section:load). */
(function () {
  var fmt = function (n) {
    try { return new Intl.NumberFormat('es-CL').format(Math.round(n)); }
    catch (e) { return String(Math.round(n)); }
  };

  function run(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var to = parseFloat(el.dataset.countTo);
    if (isNaN(to)) return;
    var pre = el.dataset.countPrefix || '';
    var suf = el.dataset.countSuffix || '';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { el.textContent = pre + fmt(to) + suf; return; }
    var dur = 1300, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + fmt(to * eased) + suf;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = pre + fmt(to) + suf;
    }
    requestAnimationFrame(step);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-count-to]:not([data-counted])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, run);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
